import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import detect from "i18next-browser-languagedetector";
import trEnCommon from "./en/common.json"
import trFrCommon from "./fr/common.json"
import trEnPageIntro from "./en/pageIntro.json"
import trFrPageIntro from "./fr/pageIntro.json"
import trEnPageBasics from "./en/pageBasics.json"
import trFrPageBasics from "./fr/pageBasics.json"
import trEnPractice from "./en/practice.json"
import trFrPractice from "./fr/practice.json"

const resources = {
    en:{
        common: trEnCommon,
        pageIntro: trEnPageIntro,
        pageBasics: trEnPageBasics,
        practice: trEnPractice
    },
    fr:{
        common: trFrCommon,
        pageIntro: trFrPageIntro,
        pageBasics: trFrPageBasics,
        practice: trFrPractice
    }
}


const i18n = i18next.use(initReactI18next).use(detect).use(initReactI18next);
i18n.init({
  resources: resources,
  fallbackLng: 'en',
  supportedLngs: ['en', 'fr'],
  defaultNS: 'common',
  interpolation: {
      escapeValue: false,
  }
});

export default i18next;
